import type { Component } from "solid-js";
import type { IconProps } from "./types";

const ChevronDownIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
      classList={props.classList}
    >
      <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
    </svg>
  );
};

export default ChevronDownIcon;
